import React, { memo } from "react";
import { Input, Row, Switch, Form, Col } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
// import PropTypes from 'prop-types'
const maxWidthStyle = { maxWidth: "800px" };
const inputStyle = {
  xs: { span: 24 },
  sm: { span: 16 },
  md: { span: 16 },
  lg: { span: 12 },
};
const switchMaxWidth = { width: "100px", marginTop: "5px", marginLeft: "8px" };
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 8 },
    lg: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 16 },
    lg: { span: 18 },
  },
};

const formItemLayoutWithOutLabel = {
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16, offset: 8 },
    md: { span: 16, offset: 8 },
    lg: { span: 18, offset: 6 },
  },
};

const CreateFileMappingRow = memo(function CreateFileMappingRow(props) {
  return (
    <Form.Item
      {...(props.index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
      label={props.index === 0 ? "Bulk Source File Name" : ""}
      required={false}
    >
      <Row style={maxWidthStyle}>
        <Col {...inputStyle}>
          <Input
            value={props.bulk_source_file_name}
            onChange={(e) =>
              props.updateRecord(
                props.index,
                "bulk_source_file_name",
                e.target.value
              )
            }
          />
        </Col>
        <Col style={switchMaxWidth}>
          <Switch
            // style={switchMaxWidth}
            checked={props.status}
            onChange={(e) => props.updateRecord(props.index, "status", e)}
          />
          <MinusCircleOutlined
            style={{ marginLeft: 8, verticalAlign: "middle" }}
            span={1}
            className="dynamic-delete-button"
            onClick={() => props.removeRecord(props.index)}
          />
        </Col>
      </Row>
    </Form.Item>
  );
});

// CreateFileMappingRow.propTypes = {

// }

export default CreateFileMappingRow;
